// This is how a normal module looks like. You can copy paste this
// for any new module you want to create. Then you can import it in
// main.js and call "init()" to execute the code.


const Tabs = ((($) => {
  // try to declare variables that are going to be used to improve performance
  let tabs_btn;
  let tab_count;

  // in this function you get all the div elements that need to be manipulated
  function init() {
    tabs_btn = $('.tabs-btn');
    if($(window).width() > 768) {
      $('.tabs-container').css('height', $('.tabs-content.show').height() + 'px');
    }
    else {
      $('.tabs-btn.active').css('padding-bottom', $('#'+$('.tabs-btn.active').attr('href')).height()+'px');
      $('.tabs-container').css('top', ($('.tabs-content.show').index()+1) * 40 + 'px');
      $('.tabs-container').css('height', $('.tabs-content.show').height() + 'px');
    }
    _attachEvents();
  }

  // this function attaches all the events that happen when the user interacts.
  // here is where you would also put something like window events
  function _attachEvents() {


    if($(window).width() > 768) {
      tabs_btn.on('click', function(e) {
        e.preventDefault();
        $(this).attr('href');
        $('.tabs-btn.active').removeClass('active');
        $(this).addClass('active');
        $('.tabs-container').find('.show').removeClass('show');
        $('.tabs-container').css('height', $('#'+$(this).attr('href')).height()+'px');
        $('.tabs-container').find('#'+$(this).attr('href')).addClass('show');
      });
    }
    else {
      tabs_btn.on('click', function(e) {
        e.preventDefault();
        $(this).attr('href');
        tab_count = $(this).index();
        $('.tabs-container').find('.show').removeClass('show');
        $('.tabs-container').css('height', $('#'+$(this).attr('href')).height()+'px');
        $('.tabs-container').find('#'+$(this).attr('href')).addClass('show');

        if($(this).hasClass('active')) {
          $(this).css('padding-bottom', '5px');
          $(this).removeClass('active');
          $('.tabs-container').find('.show').removeClass('show');
          $('.tabs-container').css('height', '0px');
        }
        else {
          $('.tabs-container').find('.show').removeClass('show');
          $('.tabs-container').css('height', $('#'+$(this).attr('href')).height()+'px');
          $('.tabs-container').find('#'+$(this).attr('href')).addClass('show');
          $('.tabs-btn.active').removeClass('active');
          $('.tabs-btn').css('padding-bottom', '5px');
          $('.tabs-container').css('top', (tab_count+1) * 40 + 'px');
          $(this).css('padding-bottom', $('#'+$(this).attr('href')).height()+'px');
          $(this).addClass('active');
        }
      });
    }
  }

  return {
    init,
  };
}))(jQuery);


// don't forget to export
export default Tabs;



// WEBPACK FOOTER //
// ./src/static/js/modules/tabs.js